import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { PlayingStatePaused, PlayingStatePlaying } from "../../types/currentlyPlayingState";
import { ITrackLyrics } from "../../types/trackLyrics";
import LyricsDisplay from "./LyricsDisplay";

interface IProps {
  lyricDetails?: ITrackLyrics;
  currentlyPlayingSong?: PlayingStatePlaying | PlayingStatePaused;
}

const TrackPlaying: React.FunctionComponent<IProps> = ({ lyricDetails, currentlyPlayingSong }) => {
  const track = currentlyPlayingSong?.currentlyPlayingObject.item;

  // No lyrics yet
  if (lyricDetails === undefined) {
    return (
      <Box textAlign="center">
        <CircularProgress size={30} />
      </Box>
    );
  }

  // Lyrics miss
  const lyricsAreEmpty =
    lyricDetails?.lyrics?.plainLyrics === undefined &&
    (lyricDetails?.lyrics?.syncedLyrics ?? undefined) === undefined;

  // No lyrics found
  if (lyricDetails.lyrics === undefined || lyricsAreEmpty) {
    return (
      <Box textAlign="center">
        <Typography>No lyrics found for the current track.</Typography>
      </Box>
    );
  }

  // Lyrics found
  return (
    <LyricsDisplay
      lyricsDetails={lyricDetails.lyrics}
      artist={track?.artists[0]?.name ?? ""}
      title={track?.name ?? ""}
      album={track?.album.name ?? ""}
      spotifyId={track?.id ?? ""}
      progressMs={currentlyPlayingSong?.currentlyPlayingObject?.progress_ms ?? 0}
      paused={!currentlyPlayingSong?.currentlyPlayingObject?.is_playing}
    />
  );
};

export default TrackPlaying;
